import getUpSellCarouselAdjustedPosition from "./getUpSellCarouselAdjustedPosition";
import { Fragment } from "react";

const addUpSellCarousel = ({ upSellCarousel, items, adPosition }) => {
  if (!upSellCarousel) {
    return items;
  }

  const adjustedCarouselPosition = getUpSellCarouselAdjustedPosition(
    adPosition
  );

  return [
    ...items.slice(0, adjustedCarouselPosition),
    <Fragment key="upSellCarousel">{upSellCarousel}</Fragment>,
    ...items.slice(adjustedCarouselPosition)
  ];
};

export default addUpSellCarousel;
